<template>
  <hi-page>
    <hi-page-column card width="40vw" fix-width gradient-softer gradient-top>
      <v-tabs
        v-model="tab"
        background-color="light4"
        centered
        icons-and-text
        dense
      >
        <v-tabs-slider></v-tabs-slider>

        <v-tab>
          Users
          <v-icon>mdi-account-multiple</v-icon>
        </v-tab>

        <v-tab>
          Inbound Emails
          <v-icon>mdi-email-multiple</v-icon>
        </v-tab>

        <v-tab>
          Maintenance
          <v-icon>mdi-tools</v-icon>
        </v-tab>
        <v-tabs-items v-model="tab">
          <v-tab-item style="background:none">
            <users></users>
          </v-tab-item>
          <v-tab-item style="background:none">
            <inbound-emails @select="selectEmail" />
          </v-tab-item>
          <v-tab-item background-color="transparent">
            <Maintenance
              @dbMaintenance="selectionType = 'dbMaintenance'"
              @mobileNumbersChecker="selectionType = 'mobileNumbersChecker'"
            ></Maintenance>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </hi-page-column>
    <!--    ====================== right panels ==========================-->
    <transition name="fade">
      <hi-page-column card grow v-if="selectionType === 'email'">
        <email-viewer :email="selectedItem"></email-viewer>
      </hi-page-column>
    </transition>
    <transition name="fade">
      <MaintenanceDB v-if="selectionType === 'dbMaintenance'" />
    </transition>
    <transition name="fade">
      <mobile-numbers-checker v-if="selectionType === 'mobileNumbersChecker'" />
    </transition>
  </hi-page>
</template>

<script>
import Users from "@/components/conf/users";
import HiPageColumn from "@/components/scaffold/HiPageColumn";
import HiPage from "@/components/scaffold/HiPage";
import InboundEmails from "@/components/conf/InboundEmails";
import EmailViewer from "@/components/conf/EmailViewer";

import Maintenance from "@/components/conf/Maintenance";
import MaintenanceDB from "@/components/conf/MaintenanceDB";
import MobileNumbersChecker from "@/components/conf/MobileNumbersChecker";

export default {
  name: "Conf",
  components: {
    MobileNumbersChecker,
    Maintenance,
    MaintenanceDB,
    EmailViewer,
    InboundEmails,
    HiPage,
    HiPageColumn,
    Users
  },
  data() {
    return {
      tab: null,
      selectedItem: null,
      selectionType: null
    };
  },
  methods: {
    selectEmail(email) {
      this.selectionType = "email";
      this.selectedItem = email;
      console.log(email);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/styles/variables.scss";
::v-deep .v-tabs-items {
  background: none;
}
::v-deep .v-window {
  height: calc(100% - 72px);
}
//::v-deep .v-window-item,
//.v-window-container {
//  height: 100% !important;
//}
::v-deep .v-window-item--active {
  height: 100% !important;
}
::v-deep .v-window__container {
  height: 100% !important;
}
//.tab-items-row >>> .v-window__container,
//.tab-items-row >>> .v-window-item {
//  height: 100%;
//}
</style>
